import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import EventMainPreview from "./EventMainPreview";
import TaskPreview from "./TaskPreview";

const MINUTE_MS = 60000;
export default function DayCalendar() {
  const momentToday = (time) => {
    const momentTime = moment(time);
    return moment()
      .set("hour", momentTime.hour())
      .set("minute", momentTime.minute());
  };
  const todayEvents = useSelector((state) =>
    state.tasks
      .filter(
        (t) =>
          !t.complete &&
          t.time &&
          t.time.start &&
          t.time.end &&
          moment(t.date).isSame(moment(), "date")
      )
      .map((t) => ({
        ...t,
        location: "",
        startTime: moment(t.time.start, "HH:mm"),
        endTime: moment(t.time.end, "HH:mm"),
        isEvent: true,
      }))
  );
  const events = useSelector((state) =>
    [
      ...state.calendar.events
        .filter((e) => e.days[moment().day()])
        .map((e) => ({
          ...e,
          startTime: momentToday(e.startTime),
          endTime: momentToday(e.endTime),
          isEvent: false,
        })),
      ...todayEvents,
    ].sort((a, b) => a.startTime.valueOf() - b.startTime.valueOf())
  );

  const getTimeDiff = (timeA, timeB, abs = true) => {
    const diff = abs ? Math.abs(timeA.diff(timeB)) : timeA.diff(timeB);
    return diff;
  };
  const getLinePos = () => {
    const time = moment();
    let offset = 0;
    events.forEach((e, i) => {
      if (e.startTime.isBefore(time)) {
        if (e.endTime.isBefore(time)) {
          //in between
          offset = i * 90 + 60;
          if (i != events.length - 1) {
            //middle
            const timeSinceEnd = getTimeDiff(time, e.endTime);
            const totalTime = getTimeDiff(e.endTime, events[i + 1].startTime);
            const extra = timeSinceEnd / totalTime;
            offset = offset + 30 * extra;
          } else {
            offset = offset + 5; //end of day
          }
        } else {
          const timeSinceStart = getTimeDiff(time, e.startTime);
          const totalTime = getTimeDiff(e.endTime, e.startTime);
          const extra = timeSinceStart / totalTime;

          offset = i * 90 + extra * 60;
        }
      }
    });
    return offset;
  };
  const updateLinePos = () => {
    setLinePos(getLinePos());
  };
  const [linePos, setLinePos] = useState(getLinePos());
  useEffect(() => {
    const interval = setInterval(() => {
      updateLinePos();
    }, MINUTE_MS);

    return () => clearInterval(interval);
  }, []);
  useEffect(() => {
    updateLinePos();
  }, [events]);
  const onClick = (event) => {};

  const getDifference = (timeA, timeB) => {
    const diff = getTimeDiff(timeA, timeB);
    const hourDiff = diff / 3600000;
    const hours = Math.floor(hourDiff);
    const minutes = Math.floor((hourDiff - hours) * 60);
    return ` ${hours > 0 ? `${hours}hr` : ""} ${
      minutes > 0 || hours == 0 ? `${minutes}min` : ""
    } `;
  };
  const isBefore = (timeA, timeB) => {
    const diff = timeA.diff(timeB);
    return diff < 60000;
  };

  const getEvent = (event, i) => {
    return (
      <div key={event.id}>
        {event.id !== events[0].id && (
          <div
            style={{
              fontSize: "15px",
              color: "#888",
              textAlign: "center",
              height: "20px",
              color: isBefore(events[i - 1].endTime, event.startTime)
                ? "black"
                : "red",
            }}
          >
            {isBefore(events[i - 1].endTime, event.startTime)
              ? `———${getDifference(event.startTime, events[i - 1].endTime)}———`
              : `Conflict: ${getDifference(
                  event.startTime,
                  events[i - 1].endTime
                )}`}
          </div>
        )}
        <EventMainPreview event={event} onClick={onClick} />
      </div>
    );
  };
  return (
    <div
      style={{
        backgroundColor: "white",
        padding: "10px",
        paddingTop: 0,
        margin: "2px",
        marginTop: 0,
        // borderRadius: "20px",
        // boxShadow: "-5px 10px 10px 3px #888888",
      }}
    >
      {/* <div style={{ textAlign: "center", fontSize: 25, paddingBottom: "5px" }}>
        Calendar
      </div> */}
      <div style={{ position: "relative" }}>
        <div
          style={{
            position: "absolute",
            backgroundColor: "red",
            height: "1px",
            width: "100%",
            top: linePos,
          }}
        />
        {events.map((e, i) => getEvent(e, i))}
      </div>
    </div>
  );
}
